import documentDownload from 'src/utils/commonMethods/documentDownload'
import { COLORS } from 'src/utils/Themes/colors'
import download_icon from 'src/assets/Button_images/download.svg'
import { makeStyles } from '@material-ui/core'

const ViewHNIReport = ({ reportData }) => {
  const classes = useStyles()

  const uploadedFileDetails = (item) => {
    return (
      <>
        <div className={classes.fileDetailsConatiner}>
          <span>{item?.originalName}</span>
          <span>
            <img
              src={download_icon}
              title='Download File'
              alt='Download File'
              className={classes.downloadIcon}
              onClick={() => handleDocumentDownload([item], null)}
            />
          </span>
        </div>
      </>
    )
  }

  const handleDocumentDownload = async (document, documentURL) => {
    documentDownload(document ? document : [], documentURL)
  }

  return (
    <div>
      <div className={classes.reportTitle}>Download Risk Reports</div>
      {reportData?.HNI?.length || reportData?.RISK_REPORT?.length ? (
        <div>
          <div className={classes.reportCategory}>Reports</div>
          <div>
            {reportData?.HNI?.map((item) => {
              return uploadedFileDetails(item)
            })}
            {reportData?.RISK_REPORT?.map((item) => {
              return uploadedFileDetails(item)
            })}
          </div>
        </div>
      ) : null}

      {reportData?.QUOTES?.length ? (
        <div>
          <div className={classes.reportCategory}>Quotes</div>
          <div>
            {reportData?.QUOTES?.map((item) => {
              return uploadedFileDetails(item)
            })}
          </div>
        </div>
      ) : null}
      {reportData?.RFQ?.length ? (
        <div>
          <div className={classes.reportCategory}>RFQs</div>
          <div>
            {reportData?.RFQ?.map((item) => {
              return uploadedFileDetails(item)
            })}
          </div>
        </div>
      ) : null}
      {reportData?.OTHERS?.length ? (
        <div>
          <div className={classes.reportCategory}>Others</div>
          <div>
            {reportData?.OTHERS?.map((item) => {
              return uploadedFileDetails(item)
            })}
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default ViewHNIReport

const useStyles = makeStyles({
  fileDetailsConatiner: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  downloadIcon: {
    height: '20px',
    width: '25px',
    cursor: 'pointer',
  },
  reportCategory: {
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: 'bold',
    color: '#333333',
    marginBottom: 'unset',
    paddingTop: '5px',
  },
  reportTitle: {
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: 'bold',
    color: COLORS.DARK_PINK,
    marginBottom: 'unset',
    paddingTop: '5px',
  },
})
